// @Version: 1.0.0
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute,} from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TRANSLATE_PATH } from '../../shared.model';

UntilDestroy()
@Component({
   selector: 'app-maintenance-work',
   templateUrl: './maintenance-work.component.html',
   standalone: false
})

export class MaintenanceWorkComponent implements OnInit, OnDestroy {
   public TRANSLATE_PATH = TRANSLATE_PATH; 

   public codeNumber: number = 0; 

   constructor (private activatedRoute: ActivatedRoute) {
   }

   ngOnInit (): void {
      this.activatedRoute.queryParams.subscribe(params => this.codeNumber = params["code"] || 999 );
   }

   ngOnDestroy(): void {
      this.codeNumber = 0; 
   }
}